export const CLEAR_FILTER_BUTTON = 'left_rail_lhf.clear_filter_button';